import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";

export default function AdminSections() {
  const [sections, setSections] = useState([]);

  const load = () => api.get("/sections").then((r) => setSections(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (key, enabled) => {
    try {
      await api.put(`/admin/sections/${key}`, { enabled });
      toast.success("Section updated");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const saveOrder = async (key, order) => {
    try {
      await api.put(`/admin/sections/${key}`, { order: parseInt(order, 10) || 0 });
      toast.success("Order updated");
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const primary = sections.filter((s) => !s.key.startsWith("hero_metric_"));
  const heroMetrics = sections
    .filter((s) => s.key.startsWith("hero_metric_"))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <div data-testid="admin-sections">
      <span className="eyebrow">Interactive sections</span>
      <h1 className="mt-2 text-3xl text-navy">Section Visibility</h1>
      <span className="divider-gold" />
      <div className="card-elev divide-y divide-navy/10">
        {primary.map((s) => (
          <div key={s.key} className="p-5 flex items-center justify-between" data-testid={`section-row-${s.key}`}>
            <div>
              <div className="text-navy font-medium">{s.name_en}</div>
              <div className="text-xs text-navy/60">{s.name_ar}</div>
            </div>
            <Switch
              data-testid={`section-toggle-${s.key}`}
              checked={s.enabled}
              onCheckedChange={(v) => toggle(s.key, v)}
            />
          </div>
        ))}
      </div>

      {heroMetrics.length > 0 && (
        <>
          <div className="mt-10">
            <span className="eyebrow">Homepage · Platform activity</span>
            <h2 className="mt-2 text-2xl text-navy">Hero Metrics</h2>
            <p className="text-xs text-navy/60 mt-1">
              Numbers are always computed from real aggregate data. You can only
              control which metrics show on the homepage and in what order.
            </p>
            <span className="divider-gold" />
          </div>
          <div className="card-elev divide-y divide-navy/10">
            {heroMetrics.map((s) => (
              <div key={s.key} className="p-5 flex items-center justify-between gap-4" data-testid={`hero-metric-row-${s.key}`}>
                <div className="flex-1">
                  <div className="text-navy font-medium">{s.name_en}</div>
                  <div className="text-xs text-navy/60">{s.name_ar}</div>
                </div>
                <label className="flex items-center gap-2 text-xs text-navy/70">
                  Order
                  <input
                    type="number"
                    className="field-box w-20 text-center"
                    defaultValue={s.order ?? 0}
                    onBlur={(e) => {
                      const v = parseInt(e.target.value, 10) || 0;
                      if (v !== (s.order ?? 0)) saveOrder(s.key, v);
                    }}
                    data-testid={`hero-metric-order-${s.key}`}
                  />
                </label>
                <Switch
                  data-testid={`hero-metric-toggle-${s.key}`}
                  checked={s.enabled}
                  onCheckedChange={(v) => toggle(s.key, v)}
                />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
